// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images//active-flag.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images//inactive-flag.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.reachItTable {
    padding: 1rem;
    background-color: #f0f0f0;
}

.reachItTable {
    padding: 1rem;
}

.reachItTable .active-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.reachItTable .inactive-flag {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
    height: 18px;
    width: 18px;
    background-position: center;
    margin: 0 0.3rem;
    margin-left: 2.03rem;
}

.monthlyFileContainer {
    background-color: white;
    border-bottom-right-radius: 1.25rem;
    border-bottom-left-radius: 1.25rem;
    border-top-right-radius: 1.25rem;
    padding: 5px;
    height: 683px;
}

.monthlyFileContainer div {
    font-size: 13px !important;
    font-weight: bold;
}

.textDisplay {
    text-align: left;
    padding-top: 5px;
}
.reachItTable {
    min-height: 260px !important;
    height: 460px;
}
.reachItTable.minHtDealer {
    min-height: 298px !important;
    height: 500px;
}
.reachItTable.minHtAdmin{
    min-height: 390px !important;
    height: 585px;
}
.reachItTable table {
    width: 51% !important;
}
.reachItTable.minHtDealer table {
    width: 30% !important;
}
.reachItTable tbody {
    overflow-y: auto;
    max-height: 410px;
}
.reachItTable.minHtDealer tbody {
    overflow-y: auto;
    max-height: 410px;
}
.reachItTable.minHtAdmin tbody{
    overflow-y: auto;
    max-height: 522px;
}
.reachItTable tbody,
.reachItTable tr {
    display: block;
}

.reachItTable tr:after {
    content: ' ';
    display: block;
    visibility: hidden;
    clear: both;
}

.reachItTable tbody>tr>td {
    float: left;
}

.reachItTable thead>tr>th {
    float: left;
}

.paddingTab {
    padding-top: 3rem;
}

.uploadContainer .nav-link {
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
}

.uploadContainer.tab-content {
    min-height: 779px;
}

.nav-tabs {
    border-bottom: 0px !important;
}

.nav-tabs .nav-item {
    width: 24%;
    text-align: center;
    font-size: 0.81rem;
}

.nav-tabs>li:first-child>a {
    border-top-left-radius: 1.25rem;
}

.nav-tabs>li:last-child>a {
    border-top-right-radius: 1.25rem;
}

.trClass {
    border-bottom: 0px solid #f0f0f0 !important;
}

.table {
    margin-bottom: 0rem !important;
}
.actionPlanTableModal.bgclr thead {
    background-color: #f1f1f1;
}
.modal-dialog.targetClassNew {
    max-width: 80rem !important;
}
.actionPlanTableModal.tblht tbody {
    border: solid 1px #a8aaac;
    min-height: 38vh;
    height: 38vh;
    overflow-y: auto !important;
}

.hideSortIcon {
    visibility: hidden 
}

.showSortIcon {
    visibility: visible !important
}
`, "",{"version":3,"sources":["webpack://./src/components/reachItDashboard/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,yDAA6D;IAC7D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yDAA+D;IAC/D,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,mCAAmC;IACnC,kCAAkC;IAClC,gCAAgC;IAChC,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;AACA;IACI,4BAA4B;IAC5B,aAAa;AACjB;AACA;IACI,4BAA4B;IAC5B,aAAa;AACjB;AACA;IACI,4BAA4B;IAC5B,aAAa;AACjB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;AACA;;IAEI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;AAClC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,2BAA2B;AAC/B;AACA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI;AACJ;;AAEA;IACI;AACJ","sourcesContent":[".reachItTable {\n    padding: 1rem;\n    background-color: #f0f0f0;\n}\n\n.reachItTable {\n    padding: 1rem;\n}\n\n.reachItTable .active-flag {\n    background-image: url(\"../../assets/images//active-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.reachItTable .inactive-flag {\n    background-image: url(\"../../assets/images//inactive-flag.png\");\n    height: 18px;\n    width: 18px;\n    background-position: center;\n    margin: 0 0.3rem;\n    margin-left: 2.03rem;\n}\n\n.monthlyFileContainer {\n    background-color: white;\n    border-bottom-right-radius: 1.25rem;\n    border-bottom-left-radius: 1.25rem;\n    border-top-right-radius: 1.25rem;\n    padding: 5px;\n    height: 683px;\n}\n\n.monthlyFileContainer div {\n    font-size: 13px !important;\n    font-weight: bold;\n}\n\n.textDisplay {\n    text-align: left;\n    padding-top: 5px;\n}\n.reachItTable {\n    min-height: 260px !important;\n    height: 460px;\n}\n.reachItTable.minHtDealer {\n    min-height: 298px !important;\n    height: 500px;\n}\n.reachItTable.minHtAdmin{\n    min-height: 390px !important;\n    height: 585px;\n}\n.reachItTable table {\n    width: 51% !important;\n}\n.reachItTable.minHtDealer table {\n    width: 30% !important;\n}\n.reachItTable tbody {\n    overflow-y: auto;\n    max-height: 410px;\n}\n.reachItTable.minHtDealer tbody {\n    overflow-y: auto;\n    max-height: 410px;\n}\n.reachItTable.minHtAdmin tbody{\n    overflow-y: auto;\n    max-height: 522px;\n}\n.reachItTable tbody,\n.reachItTable tr {\n    display: block;\n}\n\n.reachItTable tr:after {\n    content: ' ';\n    display: block;\n    visibility: hidden;\n    clear: both;\n}\n\n.reachItTable tbody>tr>td {\n    float: left;\n}\n\n.reachItTable thead>tr>th {\n    float: left;\n}\n\n.paddingTab {\n    padding-top: 3rem;\n}\n\n.uploadContainer .nav-link {\n    text-overflow: ellipsis;\n    overflow: hidden;\n    white-space: nowrap;\n}\n\n.uploadContainer.tab-content {\n    min-height: 779px;\n}\n\n.nav-tabs {\n    border-bottom: 0px !important;\n}\n\n.nav-tabs .nav-item {\n    width: 24%;\n    text-align: center;\n    font-size: 0.81rem;\n}\n\n.nav-tabs>li:first-child>a {\n    border-top-left-radius: 1.25rem;\n}\n\n.nav-tabs>li:last-child>a {\n    border-top-right-radius: 1.25rem;\n}\n\n.trClass {\n    border-bottom: 0px solid #f0f0f0 !important;\n}\n\n.table {\n    margin-bottom: 0rem !important;\n}\n.actionPlanTableModal.bgclr thead {\n    background-color: #f1f1f1;\n}\n.modal-dialog.targetClassNew {\n    max-width: 80rem !important;\n}\n.actionPlanTableModal.tblht tbody {\n    border: solid 1px #a8aaac;\n    min-height: 38vh;\n    height: 38vh;\n    overflow-y: auto !important;\n}\n\n.hideSortIcon {\n    visibility: hidden \n}\n\n.showSortIcon {\n    visibility: visible !important\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
